<template>
    <div class="container h-96 flex justify-center items-center mx-auto">
        <div class="flex flex-col">
            <div class="w-full">
                <div class="border-b border-gray-200 shadow">
                    <table>
                        <thead class="bg-gray-50 shadow-none">
                        <tr>
                            <th class="px-6 py-2 text-xs text-gray-500">
                                ID
                            </th>
                            <th class="px-6 py-2 text-xs text-gray-500">
                                Descrição
                            </th>
                            <th class="px-6 py-2 text-xs text-gray-500">
                                Valor
                            </th>
                            <th class="px-6 py-2 text-xs text-gray-500">
                                Conta
                            </th>
                        </tr>
                        </thead>
                        <tbody class="bg-white">
                        <tr class="whitespace-nowrap">
                            <td class="px-6 py-4 text-sm text-gray-500">
                                {{ payment.id }}
                            </td>
                            <td class="px-6 py-4">
                                <div class="text-sm text-gray-500">{{ payment.description }}</div>
                            </td>
                            <td class="px-6 py-4 text-sm text-gray-500">
                                {{ payment.value }}
                            </td>
                            <td class="px-6 py-4">
                                <a v-if="payment.account === 'QMulher'" href="#"
                                   class="px-4 py-1 text-sm text-white bg-blue-400 rounded">QMulher</a>
                                <a v-else href="#"
                                   class="px-4 py-1 text-sm text-white bg-red-400 rounded">Outros</a>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                    <div class="text-center">
                        <button @click="this.$emit('goBack')" type="button"
                                class="my-5 bg-white hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow">
                            Voltar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    emits: ['goBack', 'payment'],
    props: ['order'],
    setup(props) {
        const payment = {
            id: props.order.value.payment.id,
            description: props.order.value.payment.description,
            value: props.order.value.payment.value,
            account: props.order.value.account,
        }
        return {payment}
    }
}
</script>
